<template>
  <div>
    <div class="banner">
      <swiper
        ref="mySwiper"
        :options="swiperOptions"
        class="swiper-wrappe carousel"
      >
        <swiper-slide class="swiper-slide" v-for="b in banner" :key="b.img">
          <a :href="b.href || '#'"><img :src="b.img" alt=""/></a>
        </swiper-slide>

        <!-- 分页器 -->
        <div
          v-show="banner && banner.length > 1"
          class="swiper-pagination swiper-pagination-white"
          slot="pagination"
        ></div>
        <!-- 左右箭头 -->
        <div
          v-show="banner && banner.length > 1"
          class="swiper-button-prev swiper-button-white"
          slot="button-prev"
        ></div>
        <div
          v-show="banner && banner.length > 1"
          class="swiper-button-next swiper-button-white"
          slot="button-next"
        ></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'

export default {
  name: "Banner",
  components: {},
  props: {
    page: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      swiperOptions: {
        speed: 800,
        effect: "fade",
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 5000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
      },
      banner: [
      ],
      tenantInfo: {},
      loading: true
    };
  },
  created() {
    //获取banner数据
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    console.log(this.tenantConfig);
    if (this.tenantConfig.banner) {
      var banners = this.tenantConfig.banner.split(",");
      if(this.tenantConfig.bannerLinks){
        var bannerLinks = this.tenantConfig.bannerLinks.split("\n")
      }else{
        var bannerLinks = []
      }
      for (var i in banners) {
        var b = {};
        b.img = this.getQiniuUrl(banners[i]);
        if(bannerLinks.length>i){
          b.href = bannerLinks[i]
        }
        this.banner.push(b);
      }
    }
    console.log(this.banner);
    //只有一张图则隐藏分页器
    switch (this.page) {
      case "community":
        break;
      case "coures":
        break;
      default:
    }
  },
  methods: {
    getQiniuUrl,
    getQiniuFile, 
  },
};
</script>

<style lang="less" scoped>
.ant-menu {
  font-size: 20px;
  font-weight: 700;
}
.carousel {
  height: 400px;

  img {
    height: 100%;
  }
  .swiper-slide {
    background-position: center;
    background-size: cover;
  }
}
</style>